/* eslint no-console: 0 */

import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
import TurbolinksAdapter from 'vue-turbolinks'

document.addEventListener('turbolinks:load', () => {
  const SUCCESS_TIME_OUT = 1000
  const els = document.querySelectorAll('.vue-clipboard-action')
  for (let el of els) {
    new Vue({
      el,
      mixins: [TurbolinksAdapter],
      data: {
        tooltip: null,
        url: ''
      },
      methods: {
        onCopy () {
          const {success, tooltip} = this.$refs.tooltip.dataset
          this.tooltip = success
          setTimeout(() => this.tooltip = tooltip, SUCCESS_TIME_OUT)
        },
        onError (err) {
          console.error(error)
        }
      },
      mounted () {
        const {tooltip, url} = this.$refs.tooltip.dataset
        this.tooltip = tooltip
        this.url = url
      }
    })
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/components/clipboard_action.js